import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import RiskScoreResult from '../../components/RiskScoreResult';
import CalcShell from '../../components/CalcShell';
import YesNoToggle from '../../components/YesNoToggle';
import { pvRiskGroups } from '../../data/diseasesData';
import { RiskLevel } from '../../types';
import { useUserInput } from '../../context/UserInputContext';

const PvRiskCalculator: React.FC = () => {
  const { t } = useTranslation('hematology');
  const { state, update } = useUserInput();
  const input = state.pvRisk;
  const setInput = (val: typeof input) => update('pvRisk', val);

  const activeLevel = useMemo<RiskLevel | null>(() => {
    if (input.ageOver60 === null || input.priorThrombosis === null) return null;
    return input.ageOver60 || input.priorThrombosis ? 'high' : 'low';
  }, [input]);

  const inputs = (
    <>
      <YesNoToggle
        label={t('pv.ageLabel')}
        value={input.ageOver60}
        onChange={(v) => setInput({ ...input, ageOver60: v })}
        hint={t('pv.ageHint')}
      />

      <YesNoToggle
        label={t('pv.thrombosisLabel')}
        value={input.priorThrombosis}
        onChange={(v) => setInput({ ...input, priorThrombosis: v })}
      />
    </>
  );

  return (
    <CalcShell
      title="Conventional Risk Model"
      subtitle={t('pv.riskSubtitle')}
      inputs={inputs}
    >
      <RiskScoreResult
        groups={pvRiskGroups}
        activeLevel={activeLevel}
        emptyHint={t('pv.emptyHint')}
      />
    </CalcShell>
  );
};

export default PvRiskCalculator;
